<div class="confirm-modal ig-modal">
  <div class="close-button">
    <mat-icon (click)="close()">clear</mat-icon>
  </div>
  <mat-icon class="main-icon"
    [ngStyle]="{ 'color': data.confirmModalIcon==='done'?'green':data.confirmModalIcon==='help'?'#41abf3':'red'}">{{data.confirmModalIcon||'warning'}}</mat-icon>
  <h3 class="mb-1">{{ data.confirmModalTitle }}</h3>
  <div class="description" [innerHTML]="data.confirmModalDescription"></div>

  <div *ngIf="data.confirmCheckboxDescription">
    <div #confirmCheckbox><mat-checkbox [(ngModel)]="isChecked">I confirm I understand this:</mat-checkbox></div>
    <p style="color: #67757c;font-size: 14px;margin: 4px 0 12px 0">{{data.confirmCheckboxDescription}}</p>
  </div>

  <div class="button-container" style="display: flex; gap: 20px; justify-content: center; margin-top: 16px;">
    <ig-button class="warn-btn" #confirmButton [color]="data.color||'warn'" size="md" [isAsync]="data.isAsync"
      (trigger)="confirm($event)">
      {{ data.confirmModalConfirmButtonText }}
    </ig-button>
    <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
      {{ data.confirmModalCancelButtonText }}
    </div>
  </div>
</div>